import {
  Button,
  ButtonGroup,
  TextField,
} from "@mui/material";
import { Box, styled } from "@mui/system";


export const MainContentBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "tabValue",
})(({ theme, tabValue }) => ({
  borderRadius: "10px",
  color: "#fff !important",
  width: "100%",
  maxWidth: "min(90%, 750px)",
  marginTop: "clamp(3vh, 5vh, 6vh)",
  // minHeight: "clamp(25vh, 28vh, 32vh)",
  minHeight:"28vh",
  height: "210px",
  textAlign: "center",
  padding: "clamp(1rem, 2vw, 2rem)",
  position: "relative",
  zIndex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center !important",
  background: "#222324e6",
  boxShadow: "0 0 30px #0009",
  border: "1px solid rgba(112,112,112,.3) !important",
}));



export const CveTitleText = styled("p")(({ theme }) => ({
  fontWeight: "600",
  fontSize: "clamp(1rem, 1.5vw + 0.5rem, 1.5rem)",
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  color: "#FFF",
  marginBottom: "clamp(1rem, 2vh, 1.625rem) !important",
}));

export const InputField = styled(TextField)({
  width: "100%", // ~463px
  maxWidth: "380px",
  marginBottom: "1.5rem  !important", //20px
  "& .MuiOutlinedInput-root": {
    background: "rgba(30, 41, 59, 0.6)", // translucent dark
    backdropFilter: "blur(8px)", // glass effect
    borderRadius: "12px",
    border: "1px solid rgba(255, 255, 255, 0.15)",
    transition: "all 0.3s ease",

    "& fieldset": { border: "none" },

    "&:hover": {
      border: "1px solid rgba(255, 255, 255, 0.3)",
      boxShadow: "0 0 8px rgba(34, 211, 238, 0.3)", // cyan glow
    },

    "&.Mui-focused": {
      border: "1px solid rgba(34, 211, 238, 0.8)", // cyan border
      boxShadow: "0 0 12px rgba(34, 211, 238, 0.6)",
      background: "rgba(30, 41, 59, 0.8)",
    },
  },

  "& .MuiInputBase-input": {
    textAlign: "center",
    fontSize: "1rem",
    fontWeight: "600",
    color: "#fff",
    padding: "1-px ",
    fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",

    "&::placeholder": {
      color: "rgba(255,255,255,0.5)",
      fontWeight: "400",
      fontSize: "1rem",
      fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    },
  },

  // 🔹 Responsive tweaks
  "@media (max-width: 768px)": {
    maxWidth: "300px",
  },
  "@media (max-width: 480px)": {
    maxWidth: "280px",
    "& .MuiInputBase-input": {
      fontSize: "0.875rem",
      padding: "10px",
    },
  },
});



export const StyledFileInput = styled('input')({
  // ensure we target type=file since we’re styling generic input tag
  width: "100%",
  fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  color: "#fff",
  padding: "8px",
  borderRadius: "12px",
  border: "1px solid rgba(255,255,255,0.15)",
  background: "linear-gradient(135deg, #1e293b 0%, #3a4a6f 100%)",
  cursor: "pointer",
  transition: "all 0.3s ease",

  // Hide default upload button so we style our own
  "&::file-selector-button": {
    border: "none",
    padding: "10px 24px",
    marginRight: "8px",
    borderRadius: "12px",
    background: "linear-gradient(135deg, #0f1d33 0%, #2a3560 100%)",
    color: "#fff",
    fontSize: "1rem",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },

  "&::file-selector-button:hover": {
    boxShadow: "0 0 8px rgba(34,211,238,0.3)",
    background: "linear-gradient(135deg, #13233d 0%, #3b4e83 100%)",
    border: "1px solid rgba(34,211,238,0.6)",
  },

  "@media (max-width: 768px)": {
    padding: "6px",
    fontSize: "0.9rem",
  },
  "@media (max-width: 480px)": {
    padding: "4px",
    fontSize: "0.8rem",
  },
});


export const FetchButton = styled(Button)(({ theme, disabled }) => ({
  borderRadius: "50px",
    fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important",
  fontSize: "1rem",         
  fontWeight: "700",
  padding: "0.5rem 1.2rem !important",
  color: disabled ? "#666" : "#000",
  cursor: disabled ? "not-allowed" : "pointer",
  textAlign: "center",
  textTransform: "capitalize",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  whiteSpace: "nowrap",
  opacity: disabled ? 0.7 : 1,

  position: "absolute",
  left: "50%",
  bottom: 0,
  transform: "translate(-50%, 50%)",
  lineHeight: "180%",
  background: "#70F0A3",

  "@media (max-width: 480px)": {
    borderRadius: "60px !important",
    fontSize: "1.1rem",
    padding: "0.2rem 3.1rem !important",
  },
}));


export const SingleCveScoreContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "3px",
  width: "100%",
  flexWrap: "nowrap",
  position: "absolute",
  left: "50%",
  bottom: 0,
  transform: "translate(-50%, 60%)",

  "& .score": {
    backgroundColor: "#253b6a",
    background: "linear-gradient(135deg, #1e293b, #0f172a)",
    border: "1px solid rgba(255,255,255,0.1)",
    boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
    color: "#FFF",
    textAlign: "center",
    lineHeight: "1.2",
    padding: "clamp(0.5rem, 1vw + 0.3rem, 1.125rem) clamp(0.6rem, 4vw + 0.2rem, 3.750rem)",  


    "& .scoreValue": {
      fontSize: "clamp(0.625rem, 1.5vw + 0.3rem, 1.2rem)",
      fontWeight: "600",
      fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      color: "#22d3ee",
      display: "block",
    },

    "& .scoreText": {
      fontSize: "clamp(0.5rem, 1.2vw + 0.25rem, 1rem)",
      fontWeight: "600",
      fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      color: "#70F0A3",
    },
  },

  "& .epssScore": {
    borderRadius: "0 clamp(25px, 4vw, 50px) 0 0",
  },

  "& .cprScore": {
    borderRadius: "clamp(25px, 4vw, 50px) 0 0 0",
  },
}));

export const ButtonGroupStyled = styled(ButtonGroup, {
  shouldForwardProp: (prop) => prop !== "tabValue",
})(({ theme, tabValue }) => ({
  marginTop: "1.5vh !important",
  backgroundColor: "#F5F5FA !important",
  borderRadius: "50px",
  display: "inline-flex",
  // marginTop: "20px",
  position: "relative",
  "& .MuiButtonGroup-grouped": {
    lineHeight: "180%",
    // width: "150px",
    margin: "0",
    fontSize: "1rem !important",
    fontWeight: "700",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important",
    color: "#000",
    padding: "0.5vw 1.2vw !important",
  },

  "& .MuiButtonGroup-grouped:nth-of-type(1)": {
    color: tabValue === 0 ? "#000 !important" : "#3F185B",
  },
  "& .MuiButtonGroup-grouped:nth-of-type(2)": {
    color: tabValue === 1 ? "#000" : "#3F185B",
  },
 
  "@media (max-width: 480px)": {
    backgroundColor: "transparent !important",
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
    gap: "0.5rem",
    "& .MuiButtonGroup-grouped": {
      fontSize: "0.938rem", //15px
      width: "200px", 
    },
  },
 

  "@media (max-width: 320px)": {
    
    width: "100%",
    gap: "0.3rem",
    alignItems: "center",
    "& .MuiButtonGroup-grouped": {
      width: "150px",
      fontSize: "0.625rem", //10px
    },
  },
}));

export const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "active",
})(({ active }) => ({
  color: active ? "#000 !important" : "#000 !important",
  backgroundColor: active ? "#70F0A3" : "#F5F5FA",
  fontWeight: active ? "700 !important" : "400 !important",
  padding: "0.4rem 1rem !important", //12px 25px
  textTransform: "none",
  borderRadius: "50px !important",
  transition: "none",

  border: "none",
  "@media (max-width: 480px)": {
    borderRadius: "60px !important",
    fontSize: "0.813rem",
  },
}));

export const ApiResponseBox = styled(Box)(({ theme }) => ({
  maxWidth: "70%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  padding: "0",
  margin: "4rem auto 2rem auto",
  position: "relative",
  zIndex: 1,
 
}));



export const IconWrapper = styled("img")({
  width: "25px",
  height: "25px",
  "@media (max-width: 1280px)": {
    width: "20px",
    height: "20px",
  },
  "@media (max-width: 1024px)": {},
  "@media (max-width: 768px)": {},
  "@media (max-width: 480px)": {
    width: "16px",
    height: "16px",
  },
});

export const SingleRefList = styled("ul")({
  listStyleType: "none",
  padding: "0",
});

export const SingleRefListItem = styled("li")({
  marginBottom: "0.5rem",
  fontFamily: "Noto Sans",
});

export const SingleRefLink = styled("a")({
  color: "#0073e6",
  textDecoration: "none",
  wordWrap: "break-word",
  display: "block",
});
